var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
// SPDX-FileCopyrightText: 2023 Félix Robles <felix@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
import React, { useCallback, useContext, useEffect, useMemo, useRef, useState } from "react";
import { SaveButton, SimpleForm, useNotify, useRefresh, BooleanInput, useGetList, } from "react-admin";
import { useMutation, useQuery } from "@apollo/client";
import { PageHeaderStyles } from "../../components/styles/PageHeaderStyles";
import { useTranslation } from "react-i18next";
import { useTenantStore } from "@/providers/TenantContextProvider";
import { FormControl, FormControlLabel, Checkbox, FormGroup, FormLabel, Box, Autocomplete, Grid, TextField, } from "@mui/material";
import { ElectionHeaderStyles } from "@/components/styles/ElectionHeaderStyles";
import { EDIT_USER } from "@/queries/EditUser";
import { LIST_USER_ROLES } from "@/queries/ListUserRoles";
import { DataGrid } from "@mui/x-data-grid";
import { isUndefined } from "@sequentech/ui-core";
import { DELETE_USER_ROLE } from "@/queries/DeleteUserRole";
import { SET_USER_ROLE } from "@/queries/SetUserRole";
import { FormStyles } from "@/components/styles/FormStyles";
import { CREATE_USER } from "@/queries/CreateUser";
import { formatUserAtributes, getAttributeLabel, getTranslationLabel, userBasicInfo, } from "@/services/UserService";
import PhoneInput from "@/components/PhoneInput";
import SelectArea from "@/components/area/SelectArea";
import SelectActedTrustee from "./SelectActedTrustee";
import { AuthContext } from "@/providers/AuthContextProvider";
import { useAliasRenderer } from "@/hooks/useAliasRenderer";
import { InputContainerStyle, InputLabelStyle, PasswordInputStyle } from "./EditPassword";
import IconTooltip from "@/components/IconTooltip";
import { faInfoCircle } from "@fortawesome/free-solid-svg-icons";
import { useUsersPermissions } from "./useUsersPermissions";
import debounce from "lodash/debounce";
import { CustomAutocompleteArrayInput } from "@sequentech/ui-essentials";
import { useCustomNotify } from "@/hooks/useCustomNotify";
import { AUTHORIZED_ELECTION_IDS } from "./ListUsers";
export var ListUserRoles = function (_a) {
    var userRoles = _a.userRoles, rolesList = _a.rolesList, userId = _a.userId, refetch = _a.refetch, createMode = _a.createMode, setUserRoles = _a.setUserRoles, selectedRolesOnCreate = _a.selectedRolesOnCreate;
    var tenantId = useTenantStore()[0];
    var t = useTranslation().t;
    var deleteUserRole = useMutation(DELETE_USER_ROLE)[0];
    var setUserRole = useMutation(SET_USER_ROLE)[0];
    var refresh = useRefresh();
    var notify = useCustomNotify();
    var activeRoleIds = createMode
        ? selectedRolesOnCreate
        : userRoles === null || userRoles === void 0 ? void 0 : userRoles.list_user_roles.map(function (role) { return role.id || ""; });
    var rows = rolesList.map(function (role) { return (__assign(__assign({}, role), { id: role.id || "", active: (activeRoleIds === null || activeRoleIds === void 0 ? void 0 : activeRoleIds.includes(role.id || "")) || false })); });
    var editRolePermission = function (props) { return function () { return __awaiter(void 0, void 0, void 0, function () {
        var role, errors;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    role = (rolesList || []).find(function (el) { return el.id === props.row.id; });
                    if (!(role === null || role === void 0 ? void 0 : role.name)) {
                        return [2 /*return*/];
                    }
                    if (createMode && setUserRoles && role.id) {
                        setUserRoles(role.id);
                    }
                    if (!(!createMode && userId)) return [3 /*break*/, 2];
                    return [4 /*yield*/, (props.value ? deleteUserRole : setUserRole)({
                            variables: {
                                tenantId: tenantId,
                                roleId: role.id,
                                userId: userId,
                            },
                        })];
                case 1:
                    errors = (_a.sent()).errors;
                    if (errors) {
                        notify("usersAndRolesScreen.roles.notifications.permissionEditError", {
                            type: "error",
                        });
                        console.log("Error editing permission: ".concat(errors));
                        return [2 /*return*/];
                    }
                    notify("usersAndRolesScreen.roles.notifications.permissionEditSuccess", {
                        type: "success",
                    });
                    refresh();
                    if (refetch) {
                        refetch();
                    }
                    _a.label = 2;
                case 2: return [2 /*return*/];
            }
        });
    }); }; };
    var columns = [
        {
            field: "name",
            headerName: "Role",
            width: 250,
            editable: false,
        },
        {
            field: "active",
            headerName: "Active",
            editable: false,
            renderCell: function (props) { return (_jsx(Checkbox, { checked: props.value, onClick: editRolePermission(props) })); },
        },
    ];
    return (_jsx(_Fragment, { children: _jsx(DataGrid, { rows: rows, columns: columns, initialState: {
                pagination: {
                    paginationModel: {
                        pageSize: 10,
                    },
                },
            }, pageSizeOptions: [10, 20, 50, 100], style: { width: "100%" } }) }));
};
var convertRecordToUser = function (record) {
    var user = {
        id: record.id ? String(record.id) : undefined,
        attributes: record.attributes || {},
        email: record.email,
        email_verified: record.email_verified,
        enabled: record.enabled,
        first_name: record.first_name,
        last_name: record.last_name,
        username: record.username,
        area: record.area,
        votes_info: record.votes_info || [],
    };
    return user;
};
export var EditUserForm = function (_a) {
    var _b, _c, _d;
    var id = _a.id, close = _a.close, electionEventId = _a.electionEventId, electionId = _a.electionId, rolesList = _a.rolesList, userAttributes = _a.userAttributes, _e = _a.createMode, createMode = _e === void 0 ? false : _e, record = _a.record;
    var t = useTranslation().t;
    var _f = useState(createMode
        ? {
            enabled: true,
            attributes: {}, // Initialize attributes object for new users
        }
        : (record && convertRecordToUser(record)) || { attributes: {} }), user = _f[0], setUser = _f[1];
    var _g = useState(""), selectedArea = _g[0], setSelectedArea = _g[1];
    var _h = useState(""), selectedActedTrustee = _h[0], setSelectedActedTrustee = _h[1];
    var _j = useState([]), selectedRolesOnCreate = _j[0], setSelectedRolesOnCreate = _j[1];
    var _k = useState({}), phoneInputs = _k[0], setPhoneInputs = _k[1];
    var _l = useUsersPermissions(), canEditVoters = _l.canEditVoters, canEditVotersWhoVoted = _l.canEditVotersWhoVoted, canEditVotersEmailTlf = _l.canEditVotersEmailTlf;
    var tenantId = useTenantStore()[0];
    var refresh = useRefresh();
    var notify = useNotify();
    var authContext = useContext(AuthContext);
    var createUser = useMutation(CREATE_USER)[0];
    var edit_user = useMutation(EDIT_USER)[0];
    var _m = useState(((_b = user === null || user === void 0 ? void 0 : user.attributes) === null || _b === void 0 ? void 0 : _b.permission_labels) || []), permissionLabels = _m[0], setPermissionLabels = _m[1];
    var _o = useState(true), temporary = _o[0], setTemportay = _o[1];
    var _p = useState(((_d = (_c = user === null || user === void 0 ? void 0 : user.attributes) === null || _c === void 0 ? void 0 : _c.permission_labels) === null || _d === void 0 ? void 0 : _d.map(function (label) { return ({
        id: label,
        name: label,
    }); })) || []), choices = _p[0], setChoices = _p[1];
    var _q = useState(""), errorText = _q[0], setErrorText = _q[1];
    var equalToPassword = function (allValues) {
        if (!allValues.password || allValues.password.length == 0) {
            return;
        }
        if (allValues.confirm_password !== allValues.password) {
            setErrorText(t("usersAndRolesScreen.users.fields.passwordMismatch"));
        }
        if (errorText && allValues.confirm_password === allValues.password) {
            setErrorText("");
        }
    };
    useEffect(function () {
        var _a;
        var userPermissionLabels = (_a = user === null || user === void 0 ? void 0 : user.attributes) === null || _a === void 0 ? void 0 : _a.permission_labels;
        if (userPermissionLabels === null || userPermissionLabels === void 0 ? void 0 : userPermissionLabels.length) {
            setPermissionLabels(__spreadArray([], userPermissionLabels, true));
            var transformedChoices = userPermissionLabels === null || userPermissionLabels === void 0 ? void 0 : userPermissionLabels.map(function (label) { return ({
                id: label,
                name: label,
            }); });
            setChoices(__spreadArray([], transformedChoices, true));
        }
    }, [user]);
    var _r = useQuery(LIST_USER_ROLES, {
        variables: {
            tenantId: tenantId,
            userId: id,
            electionEventId: electionEventId,
        },
        skip: !id || !tenantId,
    }), userRoles = _r.data, refetch = _r.refetch;
    var voterCastVotes = useGetList("sequent_backend_cast_vote", {
        pagination: { page: 1, perPage: 10 },
        sort: { field: "last_updated_at", order: "DESC" },
        filter: {
            tenant_id: tenantId,
            election_event_id: electionEventId,
            voter_id_string: id,
        },
    }, {
        enabled: !!electionEventId,
    }).data;
    var electionsList = useGetList("sequent_backend_election", {
        pagination: { page: 1, perPage: 300 },
        sort: { field: "name", order: "DESC" },
        filter: {
            tenant_id: tenantId,
            election_event_id: electionEventId,
        },
    }, {
        enabled: !!electionEventId,
    }).data;
    // true if not affected by canEditVotersWhoVoted
    // which happens if the voter has not voted
    // or if current admin user has the permission canEditVotersWhoVoted
    var hasVoted = useMemo(function () {
        return voterCastVotes ? (voterCastVotes === null || voterCastVotes === void 0 ? void 0 : voterCastVotes.length) > 0 : false;
    }, [voterCastVotes]);
    var enabledByVoteNum = useMemo(function () {
        return canEditVotersWhoVoted || (canEditVoters && !hasVoted);
    }, [canEditVotersWhoVoted, hasVoted]);
    var handleSelectedRolesOnCreate = useCallback(function (id) {
        var existId = selectedRolesOnCreate.find(function (roleId) { return id === roleId; });
        if (existId) {
            setSelectedRolesOnCreate(function (prev) { return prev.filter(function (roleId) { return id !== roleId; }); });
        }
        else {
            setSelectedRolesOnCreate(function (prev) { return __spreadArray(__spreadArray([], prev, true), [id], false); });
        }
    }, [setSelectedRolesOnCreate, selectedRolesOnCreate]);
    var onSubmitCreateUser = function () { return __awaiter(void 0, void 0, void 0, function () {
        var _a, errors, data, error_1;
        var _b, _c;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    _d.trys.push([0, 6, , 7]);
                    return [4 /*yield*/, createUser({
                            variables: {
                                tenantId: tenantId,
                                electionEventId: electionEventId,
                                user: {
                                    id: user === null || user === void 0 ? void 0 : user.id,
                                    first_name: user === null || user === void 0 ? void 0 : user.first_name,
                                    last_name: user === null || user === void 0 ? void 0 : user.last_name,
                                    enabled: user === null || user === void 0 ? void 0 : user.enabled,
                                    email: user === null || user === void 0 ? void 0 : user.email,
                                    username: user === null || user === void 0 ? void 0 : user.username,
                                    attributes: __assign(__assign(__assign(__assign({}, formatUserAtributes(user === null || user === void 0 ? void 0 : user.attributes)), (selectedArea && { "area-id": [selectedArea] })), (phoneInputs && phoneInputs)), (selectedActedTrustee && { trustee: [selectedActedTrustee] })),
                                },
                                userRolesIds: selectedRolesOnCreate,
                            },
                        })
                        //update user password after creating user
                        //@ts-ignore because data returns create_user property but not recognized
                    ];
                case 1:
                    _a = _d.sent(), errors = _a.errors, data = _a.data;
                    //update user password after creating user
                    //@ts-ignore because data returns create_user property but not recognized
                    close === null || close === void 0 ? void 0 : close();
                    if (!errors) return [3 /*break*/, 2];
                    notify(t("usersAndRolesScreen.voters.errors.createError"), { type: "error" });
                    console.log("Error creating user: ".concat(errors));
                    return [3 /*break*/, 5];
                case 2:
                    if (!(((_c = (_b = user === null || user === void 0 ? void 0 : user.password) === null || _b === void 0 ? void 0 : _b.length) !== null && _c !== void 0 ? _c : 0) > 0 && (data === null || data === void 0 ? void 0 : data.create_user.id))) return [3 /*break*/, 4];
                    return [4 /*yield*/, handleUpdateUserPassword(data === null || data === void 0 ? void 0 : data.create_user.id)];
                case 3:
                    _d.sent();
                    _d.label = 4;
                case 4:
                    notify(t("usersAndRolesScreen.voters.errors.createSuccess"), { type: "success" });
                    refresh();
                    _d.label = 5;
                case 5: return [3 /*break*/, 7];
                case 6:
                    error_1 = _d.sent();
                    close === null || close === void 0 ? void 0 : close();
                    notify(t("usersAndRolesScreen.voters.errors.createError"), { type: "error" });
                    console.log("Error creating user: ".concat(error_1));
                    return [3 /*break*/, 7];
                case 7: return [2 /*return*/];
            }
        });
    }); };
    var onSubmit = function () { return __awaiter(void 0, void 0, void 0, function () {
        var error_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!createMode) return [3 /*break*/, 1];
                    onSubmitCreateUser();
                    return [3 /*break*/, 4];
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, handleEditUser()];
                case 2:
                    _a.sent();
                    if (authContext.userId === (user === null || user === void 0 ? void 0 : user.id)) {
                        authContext.updateTokenAndPermissionLabels();
                    }
                    notify(t("usersAndRolesScreen.voters.errors.editSuccess"), { type: "success" });
                    refresh();
                    close === null || close === void 0 ? void 0 : close();
                    return [3 /*break*/, 4];
                case 3:
                    error_2 = _a.sent();
                    notify(t("usersAndRolesScreen.voters.errors.editError"), { type: "error" });
                    close === null || close === void 0 ? void 0 : close();
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    var handleUpdateUserPassword = function (id) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, edit_user({
                    variables: {
                        body: {
                            user_id: id,
                            tenant_id: tenantId,
                            election_event_id: electionEventId,
                            password: (user === null || user === void 0 ? void 0 : user.password) && (user === null || user === void 0 ? void 0 : user.password.length) > 0 ? user.password : undefined,
                            temporary: temporary,
                        },
                    },
                })];
        });
    }); };
    var handleEditUser = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, edit_user({
                    variables: {
                        body: {
                            user_id: user === null || user === void 0 ? void 0 : user.id,
                            tenant_id: tenantId,
                            election_event_id: electionEventId,
                            first_name: user === null || user === void 0 ? void 0 : user.first_name,
                            last_name: user === null || user === void 0 ? void 0 : user.last_name,
                            enabled: user === null || user === void 0 ? void 0 : user.enabled,
                            email: user === null || user === void 0 ? void 0 : user.email,
                            password: (user === null || user === void 0 ? void 0 : user.password) && (user === null || user === void 0 ? void 0 : user.password.length) > 0 ? user.password : undefined,
                            temporary: temporary,
                            attributes: __assign(__assign(__assign(__assign({}, formatUserAtributes(user === null || user === void 0 ? void 0 : user.attributes)), (selectedArea && { "area-id": [selectedArea] })), (phoneInputs && phoneInputs)), (selectedActedTrustee && { trustee: [selectedActedTrustee] })),
                        },
                    },
                })];
        });
    }); };
    var handleChange = function (e) { return __awaiter(void 0, void 0, void 0, function () {
        var _a, name, value, updatedUser;
        var _b;
        return __generator(this, function (_c) {
            _a = e.target, name = _a.name, value = _a.value;
            updatedUser = __assign(__assign({}, user), (_b = {}, _b[name] = value, _b));
            //only run on password update
            if (name === "confirm_password" || name === "password") {
                equalToPassword(updatedUser);
            }
            setUser(updatedUser);
            return [2 /*return*/];
        });
    }); };
    var handleAttrChange = function (attrName) { return function (e) { return __awaiter(void 0, void 0, void 0, function () {
        var _a, name, value;
        return __generator(this, function (_b) {
            _a = e.target, name = _a.name, value = _a.value;
            debouncedHandleChange(name, value);
            return [2 /*return*/];
        });
    }); }; };
    var debouncedHandleChange = useCallback(debounce(function (name, value) {
        setUser(function (prev) {
            var _a;
            var _b;
            return __assign(__assign({}, prev), { attributes: __assign(__assign({}, ((_b = prev === null || prev === void 0 ? void 0 : prev.attributes) !== null && _b !== void 0 ? _b : {})), (_a = {}, _a[name] = [value], _a)) });
        });
    }, 300), [user, equalToPassword]);
    var handleDateChange = function (attrName) { return function (e) { return __awaiter(void 0, void 0, void 0, function () {
        var value;
        return __generator(this, function (_a) {
            value = e.target.value;
            setUser(function (prev) {
                var _a;
                var _b;
                return __assign(__assign({}, prev), { attributes: __assign(__assign({}, ((_b = prev === null || prev === void 0 ? void 0 : prev.attributes) !== null && _b !== void 0 ? _b : {})), (_a = {}, _a[attrName] = [value], _a)) });
            });
            return [2 /*return*/];
        });
    }); }; };
    var handleSelectChange = function (attrName) { return function (e) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            setUser(function (prev) {
                var _a;
                return __assign(__assign({}, prev), { attributes: __assign(__assign({}, prev === null || prev === void 0 ? void 0 : prev.attributes), (_a = {}, _a[attrName] = [e], _a)) });
            });
            return [2 /*return*/];
        });
    }); }; };
    var handleArraySelectChange = function (value) {
        setUser(function (prev) {
            return __assign(__assign({}, prev), { attributes: __assign(__assign({}, prev === null || prev === void 0 ? void 0 : prev.attributes), { "authorized-election-ids": value }) });
        });
    };
    var handlePermissionLabelChanged = function (value) {
        setUser(function (prev) {
            return __assign(__assign({}, prev), { attributes: __assign(__assign({}, prev === null || prev === void 0 ? void 0 : prev.attributes), { permission_labels: value }) });
        });
    };
    var handleCheckboxChange = function (attrName) { return function (choiseId) {
        var checkedItems = [choiseId];
        if (user && (user === null || user === void 0 ? void 0 : user.attributes) && (user === null || user === void 0 ? void 0 : user.attributes[attrName])) {
            var currentChecked = user.attributes[attrName];
            checkedItems = currentChecked.includes(choiseId)
                ? currentChecked.filter(function (ab) { return ab !== choiseId; })
                : __spreadArray(__spreadArray([], currentChecked, true), [choiseId], false);
        }
        setUser(function (prev) {
            var _a;
            return __assign(__assign({}, prev), { attributes: __assign(__assign({}, prev === null || prev === void 0 ? void 0 : prev.attributes), (_a = {}, _a[attrName] = checkedItems, _a)) });
        });
    }; };
    var handlePhoneNumberChange = function (attrName) { return function (number) { return __awaiter(void 0, void 0, void 0, function () {
        var phoneInput;
        return __generator(this, function (_a) {
            phoneInput = phoneInputs[attrName];
            if (!phoneInput || (phoneInput && phoneInput[0] !== number)) {
                setPhoneInputs(function (prev) {
                    var _a;
                    return __assign(__assign({}, prev), (_a = {}, _a[attrName] = [number], _a));
                });
            }
            return [2 /*return*/];
        });
    }); }; };
    var aliasRenderer = useAliasRenderer();
    var searched = useRef("");
    var electionFilterToQuery = function (searchText) {
        if (searchText && searchText.length > 0) {
            searched.current = searchText.trim();
        }
        return { "name@_ilike,alias@_ilike": searched.current };
    };
    var formattedElections = electionsList === null || electionsList === void 0 ? void 0 : electionsList.map(function (e) {
        var _a;
        return {
            external_id: (_a = e.alias) !== null && _a !== void 0 ? _a : "",
            id: e.id,
            name: aliasRenderer(e),
        };
    });
    var renderFormField = useCallback(function (attr, index) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
        if (attr.name) {
            var isCustomAttribute = !userBasicInfo.includes(attr.name);
            var value_1 = isCustomAttribute
                ? (_a = user === null || user === void 0 ? void 0 : user.attributes) === null || _a === void 0 ? void 0 : _a[attr.name]
                : user && user[attr.name];
            var displayName_1 = (_b = attr.display_name) !== null && _b !== void 0 ? _b : "";
            var isRequired_1 = isFieldRequired(attr);
            if (((_c = attr.annotations) === null || _c === void 0 ? void 0 : _c.inputType) === "select") {
                return (_jsx(Grid, __assign({ container: true, spacing: 2 }, { children: _jsx(Grid, __assign({ item: true, xs: 12 }, { children: _jsx(FormControl, __assign({ fullWidth: true }, { children: _jsx(Autocomplete, { defaultValue: value_1 || null, value: value_1 || null, onChange: function (event, newValue) {
                                    var fieldName = attr.name || "";
                                    var selectedValue = newValue || "";
                                    handleSelectChange(fieldName)(selectedValue);
                                }, options: ((_d = attr.validations.options) === null || _d === void 0 ? void 0 : _d.options)
                                    ? __spreadArray([], attr.validations.options.options, true).sort()
                                    : ["-"], getOptionLabel: function (option) { return t(option) || String(option); }, renderInput: function (params) { return (_jsx(TextField, __assign({}, params, { label: "".concat(getTranslationLabel(attr.name, attr.display_name, t), " ").concat(isRequired_1 ? "*" : "") || "-", inputProps: __assign(__assign({}, params.inputProps), { id: "autocomplete-input", required: isRequired_1, name: displayName_1 }), disabled: !(createMode ||
                                        !electionEventId ||
                                        canEditVoters ||
                                        enabledByVoteNum), fullWidth: true, style: {
                                        display: "block",
                                        visibility: "visible",
                                    } }))); }, disabled: !(createMode ||
                                    !electionEventId ||
                                    canEditVoters ||
                                    enabledByVoteNum) }) })) })) }), index));
            }
            else if (((_e = attr.annotations) === null || _e === void 0 ? void 0 : _e.inputType) === "multiselect-checkboxes" &&
                ((_f = attr.annotations) === null || _f === void 0 ? void 0 : _f.inputOptionLabels)) {
                var choices_1 = (_h = Object.entries((_g = attr.annotations) === null || _g === void 0 ? void 0 : _g.inputOptionLabels)) === null || _h === void 0 ? void 0 : _h.map(function (_a) {
                    var key = _a[0], value = _a[1];
                    return { id: key, name: getAttributeLabel(value) };
                });
                return (_jsxs(FormControl, __assign({ component: "fieldset" }, { children: [_jsx(FormLabel, __assign({ component: "legend", style: { margin: 0 } }, { children: getTranslationLabel(attr.name, attr.display_name, t) })), _jsx(FormGroup, __assign({ row: true }, { children: choices_1.map(function (choice) {
                                return (_jsx(FormControlLabel, { control: _jsx(Checkbox, { disabled: !(createMode ||
                                            !electionEventId ||
                                            canEditVoters ||
                                            enabledByVoteNum ||
                                            (!hasVoted &&
                                                attr.name === "emailAndOrMobile" &&
                                                canEditVotersEmailTlf)), checked: value_1 && value_1.includes(choice.id), onChange: function () {
                                            var _a;
                                            return handleCheckboxChange((_a = attr.name) !== null && _a !== void 0 ? _a : "")(choice.id);
                                        } }), label: choice.name }, choice.id));
                            }) }))] }), index));
            }
            else if (((_j = attr.annotations) === null || _j === void 0 ? void 0 : _j.inputType) === "html5-date") {
                return (_jsx(FormStyles.DateInput, { source: "attributes.".concat(attr.name), onChange: handleDateChange(attr.name), label: getTranslationLabel(attr.name, attr.display_name, t), disabled: !(createMode ||
                        !electionEventId ||
                        canEditVoters ||
                        enabledByVoteNum) }, index));
            }
            else if (attr.name.toLowerCase().includes("area")) {
                return;
            }
            else if (attr.name.toLowerCase().includes("mobile-number")) {
                return (_jsx(PhoneInput, { handlePhoneNumberChange: handlePhoneNumberChange(attr.name), label: getTranslationLabel(attr.name, attr.display_name, t), fullWidth: true, initialValue: value_1, disabled: !(createMode ||
                        !electionEventId ||
                        canEditVoters ||
                        enabledByVoteNum ||
                        (!hasVoted && canEditVotersEmailTlf)) }, index));
            }
            else if (attr.name.toLowerCase().includes("trustee")) {
                return (_jsx(FormControl, __assign({ fullWidth: true }, { children: _jsx(SelectActedTrustee, { label: t("usersAndRolesScreen.users.fields.trustee"), source: createMode ? "attributes.trustee" : "trustee", defaultValue: (_k = value_1 === null || value_1 === void 0 ? void 0 : value_1[0]) !== null && _k !== void 0 ? _k : "", tenantId: tenantId, onSelectTrustee: function (trustee) {
                            setSelectedActedTrustee(trustee);
                        } }) }), index));
            }
            else if (attr.name.toLowerCase().includes(AUTHORIZED_ELECTION_IDS)) {
                return (_jsx(_Fragment, { children: _jsx(FormStyles.AutocompleteArrayInput, { label: getTranslationLabel(attr.name, attr.display_name, t), className: "elections-selector", fullWidth: true, choices: formattedElections || [], source: "attributes.".concat(AUTHORIZED_ELECTION_IDS), optionValue: "external_id", optionText: "name", onChange: handleArraySelectChange, disabled: !(createMode ||
                            !electionEventId ||
                            canEditVoters ||
                            enabledByVoteNum) }, index) }));
            }
            else if (attr.name.toLowerCase().includes("permission_labels")) {
                return (_jsx(CustomAutocompleteArrayInput, { label: t("usersAndRolesScreen.users.fields.permissionLabel"), defaultValue: permissionLabels, onChange: handlePermissionLabelChanged, choices: choices, disabled: !createMode &&
                        !electionEventId &&
                        !canEditVoters &&
                        !enabledByVoteNum }, index));
            }
            return (_jsx(_Fragment, { children: isCustomAttribute ? (_jsx(FormStyles.TextField, { label: getTranslationLabel(attr.name, attr.display_name, t), value: value_1, onChange: handleAttrChange(attr.name), disabled: !(createMode ||
                        !electionEventId ||
                        canEditVoters ||
                        enabledByVoteNum ||
                        (!hasVoted &&
                            attr.name === "email" &&
                            canEditVotersEmailTlf)) }, index)) : (_jsx(FormStyles.TextInput, { label: getTranslationLabel(attr.name, attr.display_name, t), onChange: handleChange, source: attr.name, required: isFieldRequired(attr), disabled: (attr.name === "username" && !createMode) ||
                        !(createMode ||
                            !electionEventId ||
                            canEditVoters ||
                            enabledByVoteNum ||
                            (!hasVoted &&
                                attr.name === "email" &&
                                canEditVotersEmailTlf)) }, attr.display_name)) }));
        }
    }, [user, permissionLabels, choices, electionsList]);
    var isFieldRequired = function (config) {
        var _a;
        // changed: required is controlled from keycloak
        // if the user profile attribute is not null in keycloak (at tenant or election event levels),
        // then the field is required
        // exceot username thai is always required
        if ((((_a = config === null || config === void 0 ? void 0 : config.required) === null || _a === void 0 ? void 0 : _a.roles) || (config === null || config === void 0 ? void 0 : config.name) === "username") && (config === null || config === void 0 ? void 0 : config.name) !== "email") {
            return true;
        }
        return false;
    };
    var formFields = useMemo(function () {
        // to check if fields are required
        return userAttributes === null || userAttributes === void 0 ? void 0 : userAttributes.map(function (attr, index) { return (_jsx(React.Fragment, { children: renderFormField(attr, index) }, attr.name || index)); });
    }, [userAttributes, user, permissionLabels, choices, electionsList]);
    if (!user && !createMode) {
        return null;
    }
    // Update the area selection handler
    var handleAreaSelection = function (areaId) {
        if (createMode) {
            setUser(function (prev) { return (__assign(__assign({}, prev), { attributes: __assign(__assign({}, ((prev === null || prev === void 0 ? void 0 : prev.attributes) || {})), { "area-id": [areaId] }) })); });
        }
        else {
            setUser(function (prev) { return (__assign(__assign({}, prev), { area: {
                    id: areaId,
                }, attributes: __assign(__assign({}, ((prev === null || prev === void 0 ? void 0 : prev.attributes) || {})), { "area-id": [areaId] }) })); });
        }
    };
    return (_jsx(PageHeaderStyles.Wrapper, { children: _jsx(SimpleForm, __assign({ toolbar: _jsx(SaveButton, { alwaysEnable: !errorText }), record: user, onSubmit: onSubmit, sanitizeEmptyValues: true }, { children: _jsxs(_Fragment, { children: [_jsx(PageHeaderStyles.Title, { children: t("usersAndRolesScreen.".concat(electionEventId ? "voters" : "users", ".title")) }), _jsx(PageHeaderStyles.SubTitle, { children: t("usersAndRolesScreen.".concat(electionEventId ? "voters" : "users", ".subtitle")) }), formFields, _jsx(FormStyles.CheckboxControlLabel, { label: "".concat(t("usersAndRolesScreen.users.fields.enabled"), " *"), control: _jsx(Checkbox, { disabled: !(createMode ||
                                !electionEventId ||
                                canEditVoters ||
                                enabledByVoteNum), checked: (user === null || user === void 0 ? void 0 : user.enabled) || false, onChange: function (event) {
                                setUser(__assign(__assign({}, user), { enabled: event.target.checked }));
                            } }) }), electionEventId && (_jsxs(FormControl, __assign({ fullWidth: true }, { children: [_jsxs(ElectionHeaderStyles.Title, { children: [t("usersAndRolesScreen.users.fields.area"), " *"] }), _jsx(SelectArea, { tenantId: tenantId, electionEventId: electionEventId, source: createMode ? "attributes.area-id[0]" : "area.id", onSelectArea: handleAreaSelection, label: "", isRequired: true, disabled: !(createMode ||
                                    !electionEventId ||
                                    canEditVoters ||
                                    enabledByVoteNum), customStyle: {
                                    "& legend": {
                                        display: "none",
                                    },
                                } })] }))), _jsxs(_Fragment, { children: [_jsxs(FormControl, __assign({ fullWidth: true }, { children: [_jsxs(ElectionHeaderStyles.Title, { children: [t("usersAndRolesScreen.users.fields.password"), ":"] }), _jsx(PasswordInputStyle, { label: false, source: "password", onChange: handleChange, error: !!errorText, disabled: !(createMode ||
                                            !electionEventId ||
                                            canEditVoters ||
                                            enabledByVoteNum) })] })), _jsxs(FormControl, __assign({ fullWidth: true }, { children: [_jsxs(ElectionHeaderStyles.Title, { children: [t("usersAndRolesScreen.users.fields.repeatPassword"), ":"] }), _jsx(PasswordInputStyle, { label: false, source: "confirm_password", onChange: handleChange, helperText: errorText, error: !!errorText, disabled: !(createMode ||
                                            !electionEventId ||
                                            canEditVoters ||
                                            enabledByVoteNum) })] })), _jsxs(InputContainerStyle, __assign({ sx: { flexDirection: "row !important" } }, { children: [_jsx(InputLabelStyle, __assign({ paddingTop: false }, { children: _jsxs(Box, __assign({ sx: { display: "flex", gap: "8px" } }, { children: [t("usersAndRolesScreen.editPassword.temporatyLabel"), _jsx(IconTooltip, { icon: faInfoCircle, info: t("usersAndRolesScreen.editPassword.temporatyInfo") })] })) })), _jsx(BooleanInput, { source: "", label: false, onChange: function (e) { return setTemportay(!temporary); }, checked: temporary, disabled: !(createMode ||
                                            !electionEventId ||
                                            canEditVoters ||
                                            enabledByVoteNum) })] }))] }), isUndefined(electionEventId) ? (_jsx(ListUserRoles, { userRoles: userRoles, rolesList: rolesList, userId: id, refetch: function () { return refetch(); }, createMode: createMode, setUserRoles: createMode ? handleSelectedRolesOnCreate : undefined, selectedRolesOnCreate: selectedRolesOnCreate })) : null] }) })) }));
};
